import { PreventNonNumeric } from "../Functions/Utils";

// global.aadharmasking = "https://maskv7.pixl.ai"
// global.aadharreader = "https://pcs6.pixl.ai"
// global.aadharreaderback = "https://pcs6.pixl.ai"
// global.chequereader = "https://cheque.pixl.ai"
// global.qrReader = "https://pcs6.pixl.ai"
// global.ddreader = "https://ddextractor-cheque.pixl.ai"
// global.ocr = "https://pcs6.pixl.ai"
// global.ovdclasification = "https://ckyclegacy.pixl.ai"
// global.ovdExtraction = "https://classifier.pixl.ai"
// global.panreader = "https://pcs6.pixl.ai"
// global.passport = "https://pcs6.pixl.ai"
// global.invoice = "https://layout.pixl.ai"
// global.uploadData = "https://app.pixl.ai"
// global.voterid = "https://pcs6.pixl.ai"
// global.nationalid = "https://pcs6.pixl.ai"
// global.emiratesid = "https://pcs6.pixl.ai"
// global.passportverification = "https://data-verification.pixl.ai"
// global.qatarid = "https://pcs6.pixl.ai"
// global.resumeparser = "https://resume-parser.pixl.ai"
// global.mexicanIdreader = "https://pcs6.pixl.ai"
// global.mexicanInvoiceparser = "https://mexican-invoice.pixl.ai"
// global.aadhaarVerification = "https://api.kychub.com/kyc/india/v2"
// global.signVerify = "https://sign2.pixl.ai"

// ai endpoint call with app.pixl.ai
global.aadharmasking = "/Documents/Masking";
global.aadharreader = "/Documents/Reader";

global.chequereader = "/Documents/TextExtractor";
global.qrReader = "/Documents/Reader";
global.ddreader = "/Documents/TextExtractor";
global.ocr = "/Documents/Reader/";
global.ovdclasification = "/Documents/Classification/OVDClassification";
global.ovdExtraction = "https://classifier.pixl.ai";
global.panreader = "/Documents/Reader";
global.passport = "/Documents/Reader";
global.invoice = "https://layout.pixl.ai";
global.uploadData = "https://app.pixl.ai/doc-api";
// global.uploadData = "https://betaapidemo.pixl.ai";//new base url

// global.uploadData = "https://app.pixl.ai";//new base url
global.aofUpload = "/v2/AOF-Upload";
global.aofValidate = "/v2/validate-AOF-Federal";
global.invoiceparser = "/Documents/Reader/ImageToJSON";
global.checksheetProcessor = "/Documents/Reader/HyundaiChecksheetProcessing";
global.voterid = "/Documents/Reader";
global.nationalid = "/Documents/Reader";
global.emiratesid = "/Documents/Reader";
global.eVisaExtraction = "/Documents/Reader/eVisaExtraction";
global.fedFormExtraction = "/Documents/Reader/FederalBankAccountOpeningForm";
global.aofExtraction = "/Documents/Extraction/aof";
global.passportverification = "https://data-verification.pixl.ai";
global.qatarid = "/Documents/Reader";
global.resumeparser = "https://resume-parser.pixl.ai";
global.mexicanIdreader = "/Documents/Reader";
global.mexicanInvoiceparser = "/Documents/Reader/Mexicaninvoice";
global.aadhaarVerification = "https://api.kychub.com/kyc/india/v2";
global.signVerify = "https://sign2.pixl.ai";
global.malaysianID = "/Documents/Reader/MalayasianIdDataExtraction";
global.malaysianDringLicense =
  "/Documents/Reader/MalaysianDrivingLicenseDataExtraction";
global.checksheetProcessor = "/Documents/Reader/HyundaiChecksheetProcessing";
// upload api route https://app.pixl.ai
global.GetMaskedImageFile = "/Upload/GetMaskedImageFile?type="; //for get uploaded  data for aadhar masking
global.GetUploadedData = "/Upload/GetPixlDemoSampleTestResultsByType"; //for getting uploaded data for all menu
global.uploadAadharMaskingFile = "/Upload/UploadMaskedImageFile"; //for upload file for aadhar masking
global.uploadFile = "/Upload/AddPixlDemoSampleTestResults"; //for upload file for all menu
global.deleteFile = "/Upload/DeletePixlDemoSampleTestResultsById?id=";

global.InitiateAadhaarVerification =
  "/v3/verification/InitiateAadhaarVerification";
global.submitAadhar = "/v3/verification/SubmitAadhaar";
global.fetchPanDetails = "/v3/verification/PanVerification"; //pan
global.fetVoterId = "/v3/verification/VoterIDVerification"; // voterid
global.Login = "/Account/Login"; // login
global.Register = "/Account/CreateAdminUser"; // Register Admin User
global.getUserListData = "/Account/ClientUsersList";
global.fetchPanV4Details = "/v4/verification/PanVerification?"; //pan
global.fetchPassport = "/v3/verification/PassportVerification"; //passport validation
//global.getUserListData = "/doc-api/Account/ClientUsersList";
global.changePassword = "/UserMaster/changePassword";
global.Deactivate = "/UserMaster/Deactivate-Account";
global.activate = "/UserMaster/Activate-Account";
global.CreateClientUser = "/Account/CreateClientUser";
global.getMenuList = "/MenuMaster/MenuIndex";
global.CreateMenu = "/MenuMaster/CreateMenuMaster";
global.DeleteMenu = "/MenuMaster/DeleteMenu";
global.createMenuToUser = "/UserMaster/CreateUserToMenu";
global.detectSign = "/v1/detect_signature";
global.verifySign = "/v1/verify_signature";
global.EditMenuItems = "/MenuMaster/EditMenuItems";
global.ListingAllMenus = "/MenuMaster/ListingAllMenus";
global.getAllAccount = "/Account/GetAllAccounts";
global.addAccount = "/Account/Insert";
global.AccountUpdate = "/Account/Update";
global.AccountDelete = "/Account/Delete";
global.GetAccountName = "/Client/GetUserClientList";
global.ListingMenusByUser = "/MenuMaster/ListingMenusByUser";
global.DeactivateClientByUser = "/Client/DeactivateClientByUser";
global.ActivateClientByUser = "/Client/ActivateClientByUser";
global.RemoveClientByUser = "/Client/DeleteClientByUser";
//
global.getOriginalImage = "/Upload/getOriginalImage";

global.CreateAdminClient = "/Account/CreateAdminClient"; //New API//
global.GetAdminClientListing = "/UserMaster/GetAdminClientListing"; //New API//
global.ServiceDropDownValueList = "/Service/GetAllServices"; //New API//
global.MenuDropDownList = "/MenuMaster/GetAllMenus"; //New API//
global.getDocumentTypes = "/AppLog/GetDocumentTypes";
//

global.clientServices = "/Service/GetServicesByClient";
//global.AssignServicesToClientUser="/doc-api/Client/AssignServicesToClientUser"
global.getServicesByUser = "/Service/GetServicesByUser";
global.serviceAssign = "/Service/UpdateService";
global.ServiceToClient = "/Service/AssignOrUnassignServiceToClient"; // New Assign EndPoint
//global.serviceAssign = "/doc-api/Service/AssignOrUnassignServiceToClient";
global.EditMenu = "/MenuMaster/Edit";
global.overviewDowndload = "/Hit/GetSummaryReport";
global.clientService = "/Client/ClientSearching";
global.rcVerification = "/v3/verification/RCVerification";
global.bankAccountVerification = "/v3/verification/BankAccountVerification";

//integrated from api hits
global.getTotalHitCount = "/AppLog/GetTotalCount";
global.GetAppLogDetails = "/AppLog/GetApiRequestLog";
global.downloadApiLogs = "/AppLog/GetApiLogsReport";
global.getAppLogUserList = "/AppLog/GetUsers";
global.getAppLogClientList = "/AppLog/GetAccounts";
// global.

global.addNewAccounts = "/Account/Insert";

//api calls for pixl hit
global.getAccountList = "/Service/GetAccountsByUser";
global.getServicesByAccountsByUser = "/Service/GetServicesByAccountsByUser";
global.getClientsList = "/Client";
global.getAllHitBymonth = "/Hit/GetAllHitBymonth";
global.getAllClientServices = "/Hit/GetAllClientServices?";
global.GetHitsCountByStatusCode = "/Hit/GetHitsCountByStatusCode?";
global.updateClientDetails = "/Client/Update";
global.addClientDetails = "/Client/Create";
global.deleteClientDetails = "/Client/Delete";
global.updateServiceDetails = "/Service/Update";
global.addServiceDetails = "/Service/Create";
global.deleteServiceDetails = "/Service/Delete";
global.getServiceList = "/Service/Get";
global.getServiceKeyTableData = "/Service/GetServiceKeyTableData?";
global.deActivateKey = "/Service/DeactivateServiceKey?";
global.activateKey = "/Service/ActivateServiceKey?";
// global.generateKey = "/Account/GenerateClientServiceKey?";//old
global.generateKey = "/Account/GenerateKey?";
global.addServiceToClient = "/Service/AddServiceToClient";
global.getAddDataServerDeployment =
  "/ServerManagement/GetAddDataServerDeployment";
global.RefreshAadharmaskingDeploymentServerKey =
  "/Service/RefreshAadharmaskingDeploymentServerKey?";
global.getDeleteDataServerDeployment =
  "/ServerManagement/GetDeleteDataServerDeployment?";
global.addDataServerDeployment =
  "/ServerManagement/GetInsertDataServerDeployment?";
global.getUpdateDataServerDeployment =
  "/ServerManagement/GetUpdateDataServerDeployment?";
global.getHitCount = "/Hit/GetHitCount?";
global.getAllHitOfparameter = "/Hit/GetAllHitOfparameter?";
global.getStatusCodeasParameter = "/Hit/GetStatusCodeasParameter?";
global.getTranscomPdfExtration = "/documents/transcom-pdf-extration";
global.getLicenses = "/LicenseManagement/GetLicenses";

global.ExportSummary = "/Service/V3/ExportSummaryLogs";
global.getSummarylogs = "/Service/V3/GetSummaryLogs";
global.harmonyDocumentComparison = "/verification/HarmonyHealthcare";
global.equitasAofUpload = "/v2/Equitas-AOF-Upload";
global.equitasAofValidate = "/Validate-AOF-Equitas";

global.interviewNotesUpload = "/Documents/Mariapps";
global.interviewNotesDownload = "/Documents/Mariapps_Download";

// Chatbot API
global.chatBaseUrl = "https://devapi.pixl.ai/multi-agent-chatbot";
global.chatbot = "/api/chat";

global.canadianDL = "https://devapi.pixl.ai/pcs-genie-candain/v1/canadian_dl";

// header key
global.aadharmasking_header =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDbGllbnRJZCI6ImE0NmMxMmU3LTJhZmYtNDkyMS00NzQ5LTA4ZGE2YTM0ZjRlOCIsIlNlcnZpY2VJZCI6IjQzMjBmMWNjLWVmOTItNDZjYy00ZGUwLTA4ZGE2NWM0N2EyMSIsIkNyZWF0ZWRBdCI6IkphbiBNb24gMjMgMjAyMyAwOTo1NjozMSBBTSIsIm5iZiI6MTY3NDQ2Nzc5MSwiZXhwIjoxNjc0NTU0MTkxLCJpc3MiOiJodHRwczovL2xvY2FsaG9zdDo0NDM2MiIsImF1ZCI6Imh0dHBzOi8vbG9jYWxob3N0OjQ0MzYyIn0.-jWV996plYTlTfOGWI2KqdS7IR97cAI2tipe_9TloAg";
global.aadharreader_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.mexicanIdreader_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.aadharreaderback_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.mexicanInvoiceparser_header = "6673646a616b6c6768666b6a67686a6b64666762";
global.chequereader_header =
  "dsfsdfow3i234rndfsdfow3i234rn4dfow3i234rn34dfow3i234rn893m23rnfsdfsdfs4348932";
global.ddreader_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.QrReader_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.ocr_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.ovdclasification_header =
  "3E3283CE94E85C2748A791C54961B264EACD8BEA292893DEAE34E980CBE8B102";
global.panreader_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.passport_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.passportback_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.invoice_header = "17a2a4e39b9f359d272265fc2866584c";
global.voterid_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.nationalId_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.passportverification_header =
  "i234rndfssdfow3i234rn4dfow3i234rn34dfodfow3i234rn4dfow3i234rn34d3rnfsdfs48932";
global.emiratesId_header =
  "6F98193E4EE2ACA99BB40E47AA4C33B36A408167621E1E543C1D508F77E89E4F";
global.resumeparser_header =
  "dsfsdfow3i234rndfsdfow3i234rn4dfow3i234rn34dfow3i234rn893m23rnfsdfsdfs4348932";
global.ovdExtration_header =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDbGllbnRJZCI6ImE0NmMxMmU3LTJhZmYtNDkyMS00NzQ5LTA4ZGE2YTM0ZjRlOCIsIlNlcnZpY2VJZCI6ImMwNjFmOThlLTFhZjMtNGQ2Zi1jYzM0LTA4ZGIxNTgyZWRmNSIsIkNyZWF0ZWRBdCI6IkZlYiBUdWUgMjggMjAyMyAwNzowMTozNSBBTSIsIm5iZiI6MTY3NzU2NzY5NSwiZXhwIjoxNjc3NjU0MDk1LCJpc3MiOiJodHRwczovL2xvY2FsaG9zdDo0NDM2MiIsImF1ZCI6Imh0dHBzOi8vbG9jYWxob3N0OjQ0MzYyIn0.TMQdihqyL0c7nUe24x9gIbfKHgkcaU0emnOqDLe-w";

global.canadianDL_header =
  "dsfsdfow3i234rndfsdfow3i234rn4dfow3i234rn34dfow3i234rn893m23rnfsdfsdfs4348932";

export let routeList = {
  DashBoard: [
    {
      path: "/dashboard",
      sideMenuName: "DashBoard",
      name: "DashBoard",
      icon: "fas fa-file-invoice",
      section: "DashBoard",
    },
  ],
  "Document Reader": [
    {
      path: "/aadhar_Masking",
      sideMenuName: "Aadhaar Masking",
      name: "Aadhar Masking",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/pan_reader",
      sideMenuName: "PAN Card",
      name: "PANREADER",
      icon: "far fa-file-alt",
      section: "Document Reader",
    },
    {
      path: "/dd_reader",
      sideMenuName: "DD",
      name: "DDREADER",
      icon: "fas fa-id-card",
      section: "Document Reader",
    },
    {
      path: "/cheque_reader",
      sideMenuName: "Cheque",
      name: "CHEQUEREADER",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/eVisaExtraction",
      sideMenuName: "eVisa Extraction",
      name: "EVISAEXTRACTION",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/malayasianId_reader",
      sideMenuName: "Malaysian ID",
      // name: "MalayasianId Data Extraction",
      name: "MALAYSIANIDREADER",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/malaysian_DrivingLicense",
      sideMenuName: "Malaysian Driving License",
      name: "MALAYSIANDRIVINGLICENSE",
      // name: "Malaysian Driving License Data Extraction",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/mexican_invoice_Parser",
      sideMenuName: "Mexican Invoice",
      name: "MEXICANINVOICEPARSER",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/invoice_parser",
      sideMenuName: "Invoice Parser",
      name: "IMAGETOJSON",
      icon: "fas fa-file-invoice",
      section: "Invoice Extractor",
    },
    {
      path: "/checksheet_processing",
      sideMenuName: "Checksheet Processing",
      name: "CHECKSHEETPROCESSING",
      icon: "fas fa-file-invoice",
      section: "Invoice Extractor",
    },
    {
      path: "/mexican_voterid_reader",
      sideMenuName: "Mexican Voter ID",
      name: "MEXICANVOTERIDREADER",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
      isdoubleSide: true,
      documentSideKeys: [
        { key: "Mexican Voter ID Front", value: "Front" },
        { key: "Mexican Voter ID Back", value: "Back" },
      ],
    },

    {
      path: "/checksheet_processing",
      sideMenuName: "Hyundai Checksheet",
      name: "CHECKSHEETPROCESSING",
      icon: "fas fa-file-invoice",
      section: "Invoice Extractor",
    },
    {
      path: "/passportreader",
      sideMenuName: "Passport",
      name: "PASSPORTREADER",
      icon: "fas fa-file-invoice",
      isdoubleSide: true,
      documentSideKeys: [
        { key: "PassportFront", value: "Front" },
        { key: "PassportBack", value: "Back" },
      ],
      section: "Document Reader",
    },
    {
      path: "/aadharReader",
      sideMenuName: "Aadhaar Card",
      name: "AADHARREADER",
      icon: "fas fa-id-card",
      isdoubleSide: true,
      documentSideKeys: [
        { key: "Aadhaar Front", value: "Front" },
        { key: "Aadhaar Back", value: "Back" },
      ],
      section: "Document Reader",
    },
    {
      path: "/voterIdReader",
      sideMenuName: "Voter ID ",
      name: "VOTERIDREADER",
      icon: "fas fa-file-invoice",
      isdoubleSide: true,
      documentSideKeys: [
        { key: "VoterID Front", value: "Front" },
        { key: "VoterID Back", value: "Back" },
      ],
      section: "Document Reader",
    },
    {
      path: "/emiratesIdreader",
      sideMenuName: "Emirates ID",
      name: "EMIRATESIDREADER",
      icon: "fas fa-file-invoice",
      isdoubleSide: true,
      documentSideKeys: [
        { key: "EmiratesID Front", value: "Front" },
        { key: "EmiratesID Back", value: "Back" },
      ],
      section: "Document Reader",
    },
    {
      path: "/qataridreader",
      sideMenuName: "Qatar ID",
      name: "QATARIDREADER",
      icon: "fas fa-file-invoice",
      isdoubleSide: true,
      documentSideKeys: [
        { key: "QatarID Front", value: "Front" },
        { key: "QatarID Back", value: "Back" },
      ],
      section: "Document Reader",
    },
    {
      path: "/account_opening_formExtractor",
      sideMenuName: "Federal Bank AOF",
      name: "FEDERALBANKACCOUNTOPENINGFORM",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/account_opening_formExtractor",
      sideMenuName: "Federal Bank AOF V2",
      name: "FEDERALBANKACCOUNTOPENINGFORM",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/aof_extraction",
      sideMenuName: "AOF Extraction",
      name: "AOFEXTRACTION",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/Pdf_Extraction",
      sideMenuName: " Pdf Extraction",
      name: "TRANSCOMPDFEXTRATION",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
    {
      path: "/canadian_DL",
      sideMenuName: "Canadian Driving License",
      name: "CANADIANDL",
      icon: "fas fa-file-invoice",
      section: "Document Reader",
    },
  ],
  "Document Compare": [
    {
      path: "/document_comparison",
      sideMenuName: "Document Comparison",
      name: "HARMONYHEALTH",
      icon: "fas fa-file-invoice",
      section: "Document Compare",
    },
  ],

  "Document Masking": [
    {
      path: "/aadhar_Masking",
      sideMenuName: "Aadhaar Card",
      name: "AADHARMASKING",
      icon: "fas fa-file-invoice",
      section: "Document Masking",
    },
  ],
  "Document Verification": [
    {
      path: "/aadhaar_verification",
      sideMenuName: "Aadhaar Card",
      name: "AADHARVERIFICATION",
      icon: "fas fa-file-invoice",
      section: "Document Verification",
      discriptionHead: "Aadhaar Verification",
      discription:
        "The offline Aadhaar Card Verification Service is used by Aadhaar cardholders to confidentially verify their identities offline. With the use of e-KYC service get your identity authenticated and verified without delay, without needing to expose your Aadhaar number.Aadhaar Offline eKYC data are transferred to the XML file following the inputs.",
      fields: [
        {
          mainHead: "Aadhaar verification",
          placeholder: "Please enter your Aadhaar Number",
          type: "tel",
          sideMenuName: "",
          name: "aadhaarNumber",
          preventData: PreventNonNumeric,
          max: 12,
          regex: /[^0-9 ]/g,
        },
      ],
    },
    {
      path: "/passport_validation",
      sideMenuName: "Passport",
      name: "PASSPORTVERIFICATION",
      icon: "fas fa-id-card",
      section: "Document Verification",
      discriptionHead: "Passport Verification",
      discription:
        "Pixl's Passport Number verification API lets you verify the user's legitimacy with ease and assurance. You can use this to guard against fraudulent behavior while verifying the identity of your client. It is safe and practical for some organizations and businesses to use online Passport verification API applications to check the reliability of their clients.",
      fields: [
        {
          mainHead: "Passport Verification",
          placeholder: "Please enter your File Number",
          type: "text",
          sideMenuName: "",
          name: "number",
          max: 15,
          regex: /[^a-zA-Z0-9\s]/g,
        },
        // {
        //   mainHead: "",
        //   placeholder: "Please enter your Passport Number",
        //   type: "text",
        //   sideMenuName: "",
        //   name: "passport_no",
        //   max: 10,
        //   regex: /[^a-zA-Z0-9\s]/g,
        // },
        {
          mainHead: "",
          placeholder: "Please enter your Date of Birth",
          type: "date",
          sideMenuName: "",
          name: "dob",
        },
      ],
    },
    {
      path: "/pan_validation",
      sideMenuName: "PAN Card",
      name: "PANCARDVERIFICATION",
      discriptionHead: "FetchPAN",
      icon: "fas fa-file-invoice",
      section: "Document Verification",
      discription:
        "PAN Verification API can be used to verify PAN cards online in a reliable and accessible way. Every individual needs to be outfitted with their PAN card in order to register as an eligible taxpayer. Another primary reason to have a PAN card is to open a bank account. The PAN card of every competing individual is verified to be certain that they are not a fraudster or involved in illegal practices.",
      fields: [
        {
          mainHead: "PAN Verification",
          placeholder: "Please enter your  Pan Number",
          type: "text",
          sideMenuName: "",
          name: "panno",
          max: 10,
          regex: /[^a-zA-Z0-9\s]/g,
        },
      ],
    },
    {
      path: "/pan_verification_V4",
      sideMenuName: "PAN Verification V4",
      name: "PANVERIFICATIONV4",
      discriptionHead: "FetchPAN",
      icon: "fas fa-file-invoice",
      section: "Document Verification",
      discription:
        "PAN Verification API can be used to verify PAN cards online in a reliable and accessible way. Every individual needs to be outfitted with their PAN card in order to register as an eligible taxpayer. Another primary reason to have a PAN card is to open a bank account. The PAN card of every competing individual is verified to be certain that they are not a fraudster or involved in illegal practices.",
      fields: [
        {
          mainHead: "PAN Verification",
          placeholder: "Please enter your  Pan Number",
          type: "text",
          sideMenuName: "",
          name: "panno",
          max: 10,
          regex: /[^a-zA-Z0-9\s]/g,
        },
      ],
    },
    {
      path: "/rc_verification",
      sideMenuName: "RC Verification",
      name: "RCVERIFICATION",
      discriptionHead: "RC Verifcation",
      icon: "fas fa-file-invoice",
      section: "Document Verification",
      discription:
        "RC Verification API provides a seamless way to verify the authenticity of vehicle registration certificates online. This verification process is crucial for vehicle owners to ensure compliance with legal requirements and to prevent fraudulent activities. Having a valid RC is essential for various purposes, including vehicle transfer, insurance claims, and obtaining loans against the vehicle. The RC verification process helps confirm that the vehicle's details match the information stored in the official database, ensuring that the vehicle is not stolen or involved in any illegal activities. By utilizing RC verification, individuals and businesses can ensure safer transactions and uphold regulatory standards in vehicle ownership.",
      fields: [
        {
          mainHead: "RC Verification",
          placeholder: "Please enter your RC Number",
          type: "text",
          sideMenuName: "",
          name: "vehicle_number",
          max: 10, // Optional, since regex will enforce length and structure.
          regex: /[^a-zA-Z0-9\s]/g,
        },
      ],
    },

    {
      path: "/bank_account_verification",
      sideMenuName: "Bank Account Verification",
      name: "BANKACCOUNTVERIFICATION",
      icon: "fas fa-id-card",
      section: "Document Verification",
      discriptionHead: "Bank Account Verification",
      discription:
        "Bank Verification API enables secure and instant verification of bank account details, ensuring that the account information provided by an individual or business is valid and matches the records held by the financial institution. This process is essential for fraud prevention, identity verification, and seamless onboarding in financial services. By verifying bank accounts, organizations can reduce the risk of unauthorized transactions, streamline payment processes, and enhance trust with customers. Bank verification is commonly used for loan disbursement, salary deposits, and other financial transactions, helping ensure that funds are transferred to the correct recipient without delays or discrepancies.",
      fields: [
        {
          mainHead: "Bank Account Verification",
          placeholder: "Please enter your bank Account Number",
          type: "tel",
          sideMenuName: "",
          name: "accountNumber",
          preventData: PreventNonNumeric,
          max: 18,
          regex: /[^0-9 ]/g,
        },
        {
          mainHead: "",
          placeholder: "Please enter your IFSC Code",
          type: "text",
          sideMenuName: "",
          max: 11,
          name: "ifscCode",
          regex: /[^a-zA-Z0-9\s]/g,
        },
        {
          mainHead: "",
          placeholder: "Please enter your Name",
          type: "text",
          sideMenuName: "",
          name: "username",
          max: 25,
          regex: /[^a-zA-Z\s]/g, // Allows only letters and spaces
        },
        {
          mainHead: "",
          placeholder: "Please enter your Phone",
          type: "tel",
          sideMenuName: "",
          max: 10,
          preventData: PreventNonNumeric,
          name: "mobileNumber",
          regex: /[^0-9 ]/g,
        },
      ],
    },
    {
      path: "/voterId_validation",
      sideMenuName: "Voter ID",
      name: "VOTERIDVERIFICATION",
      icon: "fas fa-file-invoice",
      section: "Document Verification",
      discriptionHead: "Voter ID Verification",
      discription:
        "A voter ID is regarded as one of the most essential documents that a citizen holds in India. It helps anyone register to vote as well as verification of their identity and apply for loans, investments, and various Government initiatives and financial aid. Fraud detection can be performed in real-time by using Pixl's Voter ID verification API to verify quickly, accurately, and effortlessly.",
      fields: [
        {
          mainHead: "Voter ID Verification",
          placeholder: "Please enter your Voter ID ",
          type: "text",
          sideMenuName: "",
          name: "number",
          max: 10,
          regex: /[^a-zA-Z0-9\s]/g,
        },
      ],
    },
  ],
  "OVD Classification": [
    {
      path: "/ovd_classification",
      sideMenuName: "OVD Classify",
      name: "OVDCLASSIFICATION",
      icon: "fas fa-file-invoice",
      section: "OVD Classification",
    },
  ],
  "Signature Varification": [
    {
      path: "/signature_matching",
      sideMenuName: "Sign Matching",
      name: "SignatureMatching",
      icon: "fas fa-file-invoice",
      section: "Signature Varification",
    },
  ],
  "Signature Croping": [
    {
      path: "/signature_crop",
      sideMenuName: "Sign Croping",
      name: "SignatureCroping",
      icon: "fas fa-file-invoice",
      section: "Signature Croping",
    },
  ],
  "Face Matching": [
    {
      path: "/face_matching",
      sideMenuName: "Face Matching",
      name: "FaceMatching",
      icon: "fas fa-file-invoice",
      section: "Face Matching",
    },
  ],
  "Scanning Documents": [
    {
      path: "/qr_scanner",
      sideMenuName: "QR Scanner",
      name: "qrreader",
      icon: "fas fa-file-invoice",
      section: "Scanning Documents",
    },
  ],
  "API Hit": [
    // {
    //   path: "/hit-dashboard",
    //   sideMenuName: "Dashboard",
    //   name: "hitdashboard",
    //   section: "Hit Dashboard",
    //   icon: "fas fa-file-invoice",
    // },
    {
      icon: "fas fa-file-invoice",
      name: "hitoverview",
      path: "/hitoverview",
      section: "API Hit",
      sideMenuName: "Overview",
    },
  ],
  "API Logs": [
    {
      icon: "fas fa-file-invoice",
      name: "api-logs",
      path: "/api-logs",
      section: "API Logs",
      // sideMenuName: "Dashboard",
    },
    {
      icon: "fas fa-file-invoice",
      name: "service-logs",
      path: "/service-logs",
      section: "API Logs2",
      // sideMenuName: "Dashboard",
    },
  ],
  "AI Chatbot": [
    {
      icon: "fas fa-file-invoice",
      name: "chatbot",
      path: "/chatbot",
      section: "AI Chatbot",
    },
  ],
};

// ["PassportFront","PassportBack"]
